import React from "react";

export class GeneralPrivacyPolicyFR extends React.Component {
    render() {
        return (
            <>
                <p>
                    Dernière mise à jour: <b>28/01/2025</b>
                    <br />
                    <br />
                </p>
                <p>
                    <br />
                    DH Healthcare GmbH, un Société de Dedalus, considère que la protection de vos données à caractère personnel et le respect de votre vie privée sont des enjeux de
                    premier plan, auxquels il entend apporter une attention toute particulière.
                    <br />
                    <br />
                    Ainsi, la présente politique de confidentialité (ci-après la « Politique ») est destinée à vous informer quant aux traitements réalisés avec vos données à
                    caractère personnel lorsque vous utilisez un portail DeepUnity PACSonWEB comme p.e. secure.pacsonweb.com (ci-après le « Site »).
                    <br />À cet égard, veuillez noter que Dedalus agit en tant que responsable du traitement de vos informations personnelles (ci-après dénommé "nous", "notre" et
                    "nos").
                    <br />
                    <br />
                    DH Healthcare GmbH confirme expressément que toutes les données à caractère personnel seront traitées conformément au règlement 2016/679 du 27 avril 2016
                    relatif à la protection des personnes physiques à l'égard du traitement des données à caractère personnel et à la libre circulation de ces données (ci-après
                    RGPD). Ceci est important et nous vous encourageons à prendre le temps de lire attentivement cette politique.
                </p>
                <h2>PORTÉE DE CETTE POLITIQUE DE CONFIDENTIALITÉ</h2>
                <p>La présente politique de confidentialité s'applique</p>
                <ul>
                    <li>
                        à toutes les informations à caractère personnel recueillies par le biais des utilisateurs de la plateforme DeepUnity PACSonWEB. Ces utilisateurs incluent
                        tous les médecins, dentistes, spécialistes, etc. qui s'inscrivent et utilisent DeepUnity PACSonWEB via un compte en tant qu'utilisateurs non enregistrés en
                        vue d'ouvrir un examen sur la base du numéro de référence et de la date de naissance.
                    </li>
                    <li>à toutes les conditions générales et autres politiques de DH Healthcare GmbH relatives aux services fournis.</li>
                </ul>
                <p>
                    Cette politique de confidentialité ne s'applique pas aux données des patients que DH Healthcare GmbH traite pour le compte des hôpitaux et services de
                    radiologie associés. Il s'agit à la fois des données médicales générées par le service de radiologie et des données médicales mises à la disposition du service
                    de radiologie par le patient lui-même via la fonctionnalité de téléchargement. À cet égard, il convient de se référer à la politique de confidentialité du
                    service de radiologie concerné.
                </p>
                <h2>1. QUELLES DONNÉES À CARACTERE PERSONNEL COLLECTONS-NOUS?</h2>
                <p>
                    Lorsque vous utilisez notre portail, nous collectons les catégories de données à caractère personnel suivantes vous concernant :
                    <br />• des données d’identification (ex : nom, prénom, adresse électronique, login, mot de passe) ;
                    <br />• des données relatives à la vie professionnelle (ex : poste occupé, domaine d’activité, employeur) ;
                    <br />• des données techniques (ex : adresse IP, type de navigateur utilisé, horodatage lors de la connexion au portail etc.) ; et
                    <br />• toute donnée à caractère personnel contenue dans les correspondances que vous nous adressez le cas échéant.
                    <br />
                    <br />
                    Dans certains cas, la communication de vos données à caractère personnel s’avère obligatoire, sans quoi nous ne pourrons pas vous fournir les services et
                    informations que vous sollicitez. Par exemple, si vous nous contactez par l’intermédiaire du Site, vous devrez nécessairement nous communiquer votre adresse
                    électronique afin que nous puissions vous répondre.
                    <br />
                    <br />
                    En tout état de cause, nous vous indiquerons quand la communication de vos données à caractère personnel s’avère obligatoire.
                    <br />
                    <br />
                    De plus, dans l’éventualité où vous seriez amené(e) à nous communiquer des données à caractère personnel de tiers, vous vous engagez à vous assurer que ces
                    personnes ont été dûment informées du traitement de leurs données à caractère personnel conformément à la présente Politique et, si cela s’avère requis, ont
                    consenti au traitement de leurs données à caractère personnel.
                </p>
                <h2>2. POURQUOI UTILISONS-NOUS VOS DONNÉES À CARACTERE PERSONNEL??</h2>
                <p>
                    Le tableau ci-dessous vous indique pour quelles finalités nous traitons vos données à caractère personnel et, pour chacune d’entre elles, la base légale
                    permettant de légitimer les traitements en cause:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>FINALITÉS</th>
                            <th>BASES LÉGALES</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Enregistrement d'un compte utilisateur avec mise en œuvre de méthodes d'authentification et d'autorisation sécurisées pertinentes. Cela inclut, par
                                exemple, l'envoi d'e-mails ou de messages texte pour les protocoles d'authentification à deux facteurs ;
                            </td>
                            <td>Le traitement est fondé sur votre consentement.</td>
                        </tr>
                        <tr>
                            <td>Envoi automatique d'e-mails lorsqu'une nouvelle étude est disponible pour l'utilisateur dans DeepUnity PACSonWEB.</td>
                            <td>Le traitement est fondé sur votre consentement.</td>
                        </tr>
                        <tr>
                            <td>La traçabilité des accès enregistrés aux informations médicales;</td>
                            <td>Le traitement est nécessaire pour respecter les obligations légales auxquelles nous sommes soumis.</td>
                        </tr>
                        <tr>
                            <td>
                                Fournir une liste d'utilisateurs enregistrés aux hôpitaux qui utilisent DeepUnity PACSonWEB pour la distribution. Cette liste ne comprend que nom,
                                prénom et numéro d'identification en tant que médecin (RIZIV, BIG, ...).
                            </td>
                            <td>Le traitement est réalisé en vertu de notre intérêt légitime qui consiste à informer nos clients sur l'utilisation des services fournis.</td>
                        </tr>
                        <tr>
                            <td>
                                Répondre aux demandes et questions que vous pourriez soumettre grâce au Site, et, plus largement, assurer la gestion de nos relations avec les
                                visiteurs du Site.
                            </td>
                            <td>contrat</td>
                        </tr>
                        <tr>
                            <td>Améliorer nos services et notre Site.</td>
                            <td>
                                Le traitement est réalisé en vertu de notre intérêt légitime qui consiste à optimiser nos outils et solutions afin de satisfaire au mieux les
                                visiteurs de notre Site, nos clients et nos prospects.
                            </td>
                        </tr>
                        <tr>
                            <td>Nous conformer aux obligations légales et réglementaires qui nous sont applicables.</td>
                            <td>Le traitement est nécessaire au respect des obligations légales auxquelles nous sommes soumis.</td>
                        </tr>
                        <tr>
                            <td>Gérer tout litige potentiel ou avéré avec vous ou des tiers.</td>
                            <td>Le traitement est réalisé en vertu de notre intérêt légitime qui consiste à défendre nos intérêts, y compris par la voie judiciaire.</td>
                        </tr>
                        <tr>
                            <td>
                                l'envoi, par des moyens automatisés (par exemple, courrier électronique, SMS, MMS, etc.) et non automatisés (par exemple, téléphone, courrier
                                ordinaire, etc.), de messages de marketing et de contenus promotionnels relatifs à nos activités, produits et services et à ceux des autres sociétés
                                du groupe Dedalus (y compris les études de marché, les enquêtes de satisfaction de la clientèle, les informations sur les webinaires et les
                                événements) (marketing).
                            </td>
                            <td>Le traitement n'est effectué que si vous donnez votre consentement spécifique.</td>
                        </tr>
                        <tr>
                            <td>
                                Transfert/partage de vos données à caractère personnel avec les autres sociétés du groupe Dedalus, opérant dans le secteur bio-médical, par des
                                moyens automatisés (par exemple, e-mail, SMS, MMS, etc.), des messages de marketing et de contenu promotionnel relatifs à leurs activités, produits
                                et services (y compris les études de marché, les enquêtes de satisfaction de la clientèle, les informations sur les webinaires et les événements) ;
                                (transfert de données à des tiers à des fins de marketing)
                            </td>
                            <td>Le traitement n'est effectué que si vous donnez votre consentement spécifique.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    En tout état de cause, veuillez noter que nous nous abstiendrons de traiter vos données à caractère personnel pour d’autres finalités qui s’avéreraient
                    incompatibles avec celles mentionnées ci-avant.
                </p>
                <h2>3. AVEC QUI PARTAGEONS-NOUS VOS DONNÉES PERSONNELLES ?</h2>
                <p>
                    Dans le cadre de nos traitements, nous sommes amenés à communiquer vos données à caractère personnel aux destinataires suivants :
                    <br />• à nos prestataires de services, fournisseurs, agents et cocontractants, dans la mesure où ceux-ci nous aident à mener à bien les finalités définies dans
                    la présente Politique (ex : nous avons recours à des prestataires de services informatiques afin d’héberger vos données à caractère personnel pour notre compte)
                    ;
                    <br />• aux autres entités du groupe Dedalus dans la mesure où ceux-ci nous aident à mener à bien les finalités définies dans la présente Politique ;
                    <br />• aux juridictions compétentes, aux autorités publiques, aux organismes gouvernementaux et aux forces de l’ordre (notamment dans les cas où nous devons
                    donner suite à des demandes légales ou réglementaires).
                    <br />
                    <br />
                    Quel que soit le destinataire concerné, nous ne lui communiquons vos données à caractère personnel que si celui-ci a strictement besoin d’en connaître et
                    uniquement dans la mesure requise pour atteindre les finalités identifiées dans la présente Politique.
                    <br />
                    <br />
                    Nous ne revendons pas vos données à caractère personnel.
                </p>
                <h2>4. RÉALISONS-NOUS DES TRANSFERTS DE DONNÉES HORS DE L’ESPACE ÉCONOMIQUE EUROPÉEN ?</h2>
                <p>
                    Pour tous les pays de l'Espace économique européen, les données personnelles de santé traitées par DeepUnity PACSonWEB ne sont pas transférées vers un pays
                    situé en dehors de cette zone.
                </p>
                <p>
                    Si vos données à caractère personnel sont transférées en dehors de l'Espace économique européen ("EEE"), nous veillerons à ce que le niveau de protection de vos
                    données à caractère personnel ne soit pas affecté par ces transferts.
                </p>
                <p>Cela signifie en particulier que chacun des transferts proposés repose sur au moins l'un des mécanismes suivants</p>
                <ul>
                    <li>
                        l'existence d'une décision d'adéquation émise par la Commission européenne pour le pays vers lequel vos données à caractère personnel seront transférées ;
                        ou, alternativement ;
                    </li>
                    <li>conclure des clauses contractuelles types adoptant les modèles approuvés par la Commission européenne ; ou bien</li>
                    <li>
                        • l'existence d'une exemption liée à l'une des situations spécifiques prévues de manière exhaustive dans le règlement général sur la protection des données
                        2016/679 ("RGPD") (par exemple, lorsque vous avez donné votre consentement à un tel transfert après avoir été informé de l'absence de garanties, lorsque le
                        transfert est nécessaire à l'exécution d'un contrat conclu entre vous et nous, lorsque le transfert est nécessaire à la conclusion ou à l'exécution d'un
                        contrat conclu dans votre intérêt entre nous et un tiers, ou lorsque le transfert est nécessaire à la constatation, à l'exercice ou à la défense de nos
                        droits en justice, et ainsi de suite).
                    </li>
                </ul>
                <h2>5. PENDANT COMBIEN DE TEMPS CONSERVONS-NOUS VOS DONNÉES À CARACTERE PERSONNEL ?</h2>
                <p>
                    Nous conservons vos données à caractère personnel pendant une durée n’excédant pas ce qui est nécessaire au regard de la finalité poursuivie par le traitement
                    concerné.
                    <br />
                    <br />
                    En d’autres termes, cela signifie que les durées de conservation que nous appliquons varient en fonction de la raison pour laquelle nous traitons les données en
                    cause. Ainsi, le tableau ci-après vous indique, pour chaque finalité, la durée de conservation qui sera appliquée à vos données à caractère personnel :{" "}
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>FINALITÉS</th>
                            <th>DURÉE DE CONSERVATION</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Enregistrement d'un compte utilisateur avec mise en œuvre de méthodes d'authentification et d'autorisation sécurisées pertinentes. Cela inclut, par
                                exemple, l'envoi d'e-mails ou de messages texte pour les protocoles d'authentification à deux facteurs ;
                            </td>
                            <td>
                                Les données à caractère personnel obtenues dans le cadre de l'enregistrement d'un compte sont conservées pour une période de 2 ans après la dernière
                                tentative fructueuse de connexion.
                            </td>
                        </tr>
                        <tr>
                            <td>Envoi automatique d'e-mails lorsqu'une nouvelle étude est disponible pour l'utilisateur dans DeepUnity PACSonWEB.</td>
                            <td>
                                Les données à caractère personnel obtenues dans le cadre de l'enregistrement d'un compte sont conservées pour une période de 2 ans après la dernière
                                tentative fructueuse de connexion.
                            </td>
                        </tr>
                        <tr>
                            <td>La traçabilité des accès enregistrés aux informations médicales;</td>
                            <td>10 ans</td>
                        </tr>
                        <tr>
                            <td>
                                Fournir une liste d'utilisateurs enregistrés aux hôpitaux qui utilisent DeepUnity PACSonWEB pour la distribution. Cette liste ne comprend que nom,
                                prénom et numéro d'identification en tant que médecin (RIZIV, BIG, ...).
                            </td>
                            <td>
                                Les données à caractère personnel obtenues dans le cadre de l'enregistrement d'un compte sont conservées pour une période de 2 ans après la dernière
                                tentative fructueuse de connexion.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Répondre aux demandes et questions que vous pourriez soumettre grâce au Site, et, plus largement, assurer la gestion de nos relations avec les
                                visiteurs du Site.
                            </td>
                            <td>
                                Répondre aux demandes et questions que vous pourriez soumettre grâce au Site, et, plus largement, assurer la gestion de nos relations avec les
                                visiteurs du Site.
                            </td>
                        </tr>
                        <tr>
                            <td>Nous conserverons vos données personnelles pendant un maximum de deux ans à compter de notre dernier contact avec vous.</td>
                            <td>Nous conserverons vos données personnelles pendant un maximum de deux ans à compter de notre dernier contact avec vous.</td>
                        </tr>
                        <tr>
                            <td>Améliorer nos services et notre Site.</td>
                            <td>Améliorer nos services et notre Site.</td>
                        </tr>
                        <tr>
                            <td>
                                Nous conserverons vos données pendant un an au maximum, même si, dans la plupart des cas, elles seront regroupées peu de temps après leur collecte
                                en statistiques non identifiables.
                            </td>
                            <td>
                                Nous conserverons vos données pendant un an au maximum, même si, dans la plupart des cas, elles seront regroupées peu de temps après leur collecte
                                en statistiques non identifiables.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                l'envoi, par des moyens automatisés (par exemple, courrier électronique, SMS, MMS, etc.) et non automatisés (par exemple, téléphone, courrier
                                ordinaire, etc.), de messages de marketing et de contenus promotionnels relatifs à nos activités, produits et services et à ceux des autres sociétés
                                du groupe Dedalus (y compris les études de marché, les enquêtes de satisfaction de la clientèle, les informations sur les webinaires et les
                                événements) (marketing).
                            </td>
                            <td>Nous traiterons vos données personnelles jusqu'à ce que votre consentement soit retiré.</td>
                        </tr>
                        <tr>
                            <td>
                                l'envoi, par des moyens automatisés (par exemple, courrier électronique, SMS, MMS, etc.) et non automatisés (par exemple, téléphone, courrier
                                ordinaire, etc.), de messages de marketing et de contenus promotionnels relatifs à nos activités, produits et services et à ceux des autres sociétés
                                du groupe Dedalus (y compris les études de marché, les enquêtes de satisfaction de la clientèle, les informations sur les webinaires et les
                                événements) (marketing).
                            </td>
                            <td>Nous traiterons vos données personnelles jusqu'à ce que votre consentement soit retiré.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    En tout état de cause, à l’expiration de la durée de conservation applicable, nous effacerons vos données à caractère personnel ou anonymiserons celles-ci de
                    manière irrévocable, de sorte que vous ne puissiez plus être identifié(e).
                </p>
                <h2>6. UTILISONS-NOUS DES COOKIES ?</h2>
                <p>
                    Nous utilisons des cookies sur notre Site. Toutefois, conformément au cadre légal applicable, veuillez noter que nous nous assurerons d’avoir obtenu votre
                    consentement préalable avant de placer ceux-ci sur votre équipement. Pour en savoir plus sur les cookies que nous utilisons et les objectifs que nous
                    poursuivons ainsi, nous vous invitons à consulter notre Politique Cookies
                </p>
                <h2>7. DE QUELS DROITS DISPOSEZ-VOUS?</h2>
                <p>
                    Conformément au cadre légal applicable en matière de protection des données, et notamment du RGPD, vous disposez des droits suivants en votre qualité de
                    personne concernée :
                    <br />• Vous pouvez solliciter l’accès à vos données à caractère personnel et demander leur rectification ou leur effacement.
                    <br />• Vous avez également le droit de demander la limitation du traitement de vos données à caractère personnel ou de vous opposer à celui-ci.
                    <br />• Vous pouvez solliciter la portabilité de vos données à caractère personnel.
                    <br />• Lorsque le traitement de vos données à caractère personnel est fondé sur votre consentement, veuillez noter que vous pouvez retirer votre celui-ci à
                    tout moment, sans porter atteinte à la licéité des traitements fondés sur votre consentement effectués avant le retrait de celui-ci.
                    <br />• Vous pouvez en outre préciser les directives relatives à l’utilisation de vos données à caractère personnel à la suite de votre décès.
                    <br />
                    <br />
                    Néanmoins, veuillez noter que certains des droits susvisés sont soumis à des conditions particulières dictées par le cadre légal applicable en matière de
                    protection des données. Ainsi, dans l’éventualité où votre situation particulière ne répondrait pas auxdites conditions, nous ne pourrions alors malheureusement
                    pas donner une suite favorable à votre demande.
                    <br />
                    <br />
                    Pour exercer vos droits, nous vous invitons à contacter notre DPO grâce aux coordonnées communiquées dans la Section 8 (Comment pouvez-vous nous contacter ?).
                    Afin de pouvoir traiter au mieux votre demande, nous pouvons être amenés à vous demander certaines informations complémentaires destinées à confirmer votre
                    identité et/ou faciliter la localisation des données à caractère personnel concernées par votre demande.
                    <br />
                    <br />
                    En tout état de cause, veuillez noter que vous pouvez introduire une réclamation auprès de l'autorité de contrôle compétente en matière de protection des
                    données. Une liste des autorités de contrôle européennes compétentes est disponible sur le site suivant :
                    <br />
                    https://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm
                </p>
                <h2>8. COMMENT POUVEZ-VOUS NOUS CONTACTER ?</h2>
                <p>
                    Si vous avez des questions ou des demandes concernant les traitements que nous réalisons avec vos données à caractère personnel dans le cadre de cette
                    Politique, y compris l’exercice de vos droits, tels que détaillés ci-dessus, vous pouvez nous contacter à l’adresse suivante :
                    <br />
                    pour Dedalus S.p.A. dpo.group@dedalus.eu
                    <br />
                    pour Millennium S.r.l. dpo.millennium@dedalus.eu
                    <br />
                    pour les autres sociétés basées en Italie dpo@dedalus.eu
                    <br />
                    pour les entreprises établies au Royaume-Uni dpo-uk@dedalus.group.
                    <br />
                    pour les entreprises établies en France dpo.france@dedalus.eu
                    <br />
                    pour les sociétés basées en Allemagne/Autriche et en Suisse dpo.dach@dedalus.com
                    <br />
                    pour DH Healthcare GmbH et d'autres sociétés basées en Belgique dpo.belgium@dedalus.eu
                    <br />
                    pour les autres sociétés dpo.group@dedalus.eu
                </p>
            </>
        );
    }
}
